import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'state/store';

export type FmrsState = {
  data: {
    billingConsent: boolean;
    preferredStartDate: string | null;
  };
};

export const initialState: FmrsState = {
  data: {
    billingConsent: false,
    preferredStartDate: null
  }
};

export const slice = createSlice({
  name: 'fmrs',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.data = initialState.data;
    },
    setBillingConsent: (state, { payload }) => {
      state.data.billingConsent = payload;
    },
    setPreferedStartDate: (state, { payload }) => {
      state.data.preferredStartDate = payload;
    }
  }
});

export const {
  setInitialState,
  setBillingConsent,
  setPreferedStartDate
} = slice.actions;

export const selectSlice = (state: RootState) => state[slice.name];
export const selectData = (state: RootState) => selectSlice(state).data;

export default slice.reducer;
